const Mygames = () => {
  return <div className="centermax">Page en travaux</div>;
};

export default Mygames;
